<template>
  <div>
    <div class="top-navigation">
      <nav class="navbar">    
        <div class="nav-container">
          <router-link class="nav-link" to="/projects">
            <img class="logo" v-bind:src="require('./assets/yggdat_logo.png')" alt="SINTEF-logo" />
          </router-link>
        </div>

        <!-- Right-side section -->
        <div class="right-section">
          <router-link
            class="help-nav-button"
            :class="{ active: isActive('/help') }"
            :to="{ name: 'HelpCenter' }"
            title="Help Center"
          >
            <i class="bi bi-question-circle" aria-hidden="true"></i>
            <span>Help</span>
          </router-link>
          <div v-if="loggedInUser" class="user-info">
            <span class="user-name">{{ loggedInUser.name }}</span>
            <div class="entities-dropdown">
              <button class="hamburger-menu" @click.stop="toggleDropdown" type="button" title="Menu">
                <span></span>
                <span></span>
                <span></span>
              </button>
              <div v-show="dropdownOpen" class="dropdown-menu">
                <router-link class="dropdown-item" to="/projects" @click="dropdownOpen = false">Projects</router-link>
                <router-link class="dropdown-item" to="/experiments" @click="dropdownOpen = false">Experiments</router-link>
                <router-link class="dropdown-item" to="/records" @click="dropdownOpen = false">Records</router-link>
                <router-link class="dropdown-item" to="/instruments" @click="dropdownOpen = false">Instruments</router-link>
                <router-link class="dropdown-item" to="/locations" @click="dropdownOpen = false">Locations</router-link>
                <router-link class="dropdown-item" to="/rental-places" @click="dropdownOpen = false">Support Expenses</router-link>
                <router-link class="dropdown-item" to="/mdlists" @click="dropdownOpen = false">Templates</router-link>
                <router-link class="dropdown-item" to="/materials" @click="dropdownOpen = false">Materials</router-link>
                <router-link class="dropdown-item" to="/project-structure" @click="dropdownOpen = false">Structure</router-link>
                <router-link class="dropdown-item" to="/export" @click="dropdownOpen = false">Export</router-link>
                <router-link class="dropdown-item" to="/help" @click="dropdownOpen = false">Help</router-link>
              </div>
            </div>
            <button class="logout-button" @click="logout">Log out</button>
          </div>
        </div>
      </nav>

      <!-- Entity Navigation Bar -->
      <div class="entity-nav" v-if="loggedInUser">
        <router-link 
          to="/projects" 
          class="entity-button"
          :class="{ active: isActive('/projects') }">
          Projects
        </router-link>
        <router-link 
          to="/experiments" 
          class="entity-button"
          :class="{ active: isActive('/experiments') }">
          Experiments
        </router-link>
        <router-link 
          to="/records" 
          class="entity-button"
          :class="{ active: isActive('/records') }">
          Records
        </router-link>
        <router-link 
          to="/instruments" 
          class="entity-button"
          :class="{ active: isActive('/instruments') }">
          Instruments
        </router-link>
        <router-link 
          to="/locations" 
          class="entity-button"
          :class="{ active: isActive('/locations') }">
          Locations
        </router-link>
        <router-link 
          to="/mdlists" 
          class="entity-button"
          :class="{ active: isActive('/mdlists') }">
          Templates
        </router-link>
        <router-link 
          to="/materials" 
          class="entity-button"
          :class="{ active: isActive('/materials') }">
          Materials
        </router-link>
        <router-link 
          to="/project-structure" 
          class="entity-button"
          :class="{ active: isActive('/project-structure') }">
          Structure
        </router-link>
        <router-link 
          to="/export" 
          class="entity-button"
          :class="{ active: isActive('/export') }">
          Export
        </router-link>
      </div>
    </div>

    <router-view/>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      users: [],
      selectedUser: '',
      dropdownOpen: false,
    };
  },
  computed: {
    ...mapState(['loggedInUser']),
  },
  methods: {
    ...mapMutations(['setLoggedInUser']),
  
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    isActive(path) {
      return this.$route.path.startsWith(path);
    },

    handleUserChange() {
      const selectedUser = this.users.find(user => user.id === parseInt(this.selectedUser));
      if (selectedUser) {
        this.setLoggedInUser(selectedUser);
      }
    },
    logout() {
      // Clear MSAL session
      const accounts = this.$msalInstance?.getAllAccounts?.();
      if (accounts && accounts.length > 0) {
        this.$msalInstance.logoutPopup?.({ account: accounts[0] });
      }

      // Clear Vuex store
      this.setLoggedInUser(null);

      // Redirect to homepage
      this.$router.push('/');
    },
  },
  mounted() {
    if (this.loggedInUser) {
      this.selectedUser = this.loggedInUser.id?.toString();
    }
  }
};
</script>


<style lang="scss">
@import "@/assets/variables.scss";

.top-navigation {
  position: sticky;
  top: 0;
  z-index: 1100;
  background-color: white;
}

.navbar {
  display: flex;
  align-items: center; /* Center items vertically */
  justify-content: space-between;
  background-color: $primary-color;
  padding: 0.5rem 1.5rem; /* Adjust padding for a more compact navbar */
  position: relative;
  z-index: 1101;
  overflow: visible;
}

.entity-nav {
  display: flex;
  align-items: center;
  background-color: white;
  border-bottom: 2px solid $primary-color;
  padding: 0;
  gap: 0;
  overflow-x: auto;

  .entity-button {
    flex-shrink: 0;
    padding: 0.5rem 1.5rem;
    color: $primary-color;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    border: none;
    background-color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 3px solid transparent;

    &:hover {
      background-color: lighten($primary-color, 40%);
    }

    &.active {
      background-color: lighten($primary-color, 40%);
      border-bottom-color: $primary-color;
      color: $primary-color;
    }
  }
}

.nav-container {
  display: flex;
  align-items: center; /* Ensure logo aligns with links */
}

.nav-link {
  color: white;
  text-decoration: none;
  margin: 0 20px;
  font-size: 1.4rem; /* Slightly smaller font size */
  padding: 5px 10px;

  &:hover {
    text-decoration: underline;
  }
}

.logo {
  max-height: 45px; /* Set a max height for the logo */
  height: auto; /* Maintain aspect ratio */
  margin-right: 20px; /* Add spacing between the logo and links */
}

.gear-button {
  color: white;
  text-decoration: none;
  margin-left: auto; /* Push the gear icon to the right */
  font-size: 1.25rem;
  padding: 5px;

  &:hover {
    color: #ddd;
  }
}

.user-dropdown {
  margin-left: 20px;

  select {
    padding: 5px;
    font-size: 1rem;
    border-radius: 4px;
    border: 1px solid $primary-color;
  }
}

.right-section {
  display: flex;
  align-items: center;
  gap: 1rem; /* Add spacing between dropdown and gear */
  margin-left: auto; /* Push this section to the right */
  overflow: visible;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: visible;
}

.help-nav-button {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  color: white;
  font-size: 0.95rem;
  text-decoration: none;
  transition: background-color 0.2s ease;

  &:hover,
  &.active {
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
  }
}

.user-name {
  color: white;
  font-size: 1rem;
}

.logout-button {
  background-color: white;
  color: $primary-color;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  font-size: 0.9rem;
  margin-right: 1rem;
  cursor: pointer;

  &:hover {
    background-color: lighten($primary-color, 10%);
    color: white;
  }
}

.entities-dropdown {
  position: relative;
  margin: 0 0.5rem;
  z-index: 1001;

  .hamburger-menu {
    background-color: white;
    border: none;
    padding: 0.4rem 0.6rem;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 35px;
    height: 35px;

    span {
      display: block;
      height: 3px;
      background-color: $primary-color;
      width: 100%;
      border-radius: 2px;
      transition: all 0.3s ease;
    }

    &:hover {
      background-color: lighten($primary-color, 10%);

      span {
        background-color: white;
      }
    }
  }

  .dropdown-menu {
    display: block;
    position: absolute;
    top: calc(100% + 5px);
    right: -50px;
    background-color: $secondary-color;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    min-width: 150px;
    z-index: 9999;
    padding: 0.5rem 0;

    .dropdown-item {
      display: block;
      padding: 0.75rem 1rem;
      color: $primary-color;
      text-decoration: none;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: $primary-color;
        color: white;
      }

      &:first-child {
        border-radius: 4px 4px 0 0;
      }

      &:last-child {
        border-radius: 0 0 4px 4px;
      }
    }
  }
}

</style>
